import { useContext, useMemo } from "react";
import { configContext } from "./context.js";
import { getPrimaryConfig } from "../configs/config.js";
import "../lib/base.js";
import { Configurable } from "../lib/configurable.js";
import { mergeRight } from "../lib/merge.js";
function useConfig() {
  const { context, config } = useContext(configContext);
  return useMemo(() => {
    if (!Object.keys(context).length)
      throw '"context" is not valid. Please provide context using <ConfigProvider />.';
    const appConfig = Configurable.of(config || {});
    const combinedConfig = getPrimaryConfig().chain(
      (primary) => appConfig.chain((app) => mergeRight(primary, app))
    );
    return combinedConfig.evaluateWithContext(context);
  }, [context]);
}
export {
  useConfig
};
//# sourceMappingURL=hooks.js.map
